<template>
 <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
             >
            <template slot="header">
            <h4 class="card-title">{{ $t('message.TRUCKER')}}</h4>
            <p class="card-category">{{ $t('message.LIST_OF_TRUCKER')}}</p>
            </template>
            <div class="row" style="margin-left:2px">
                <div class="col-md-3 form-group">
                    <label class="label">{{ $t('message.SEARCH_FILTER')}}</label>
                    <v-select :options="search_filter" v-model="search_field" class="as-input-ht"></v-select>
                </div>
                <div class="col-md-6 form-group">
                        <label class="label">{{ $t('message.SEARCH')}}</label>  
                        <input type="text" v-model="search_key"  class="form-control" >
                </div>
                <div class="col-md-3 form-group">
                    <span class="float-right" style="margin-top:24px"> 
                        <a href="javascript:void(0);"  class="btn btn-info mr-2" id="submit" @click="search_tucker()">{{ $t('message.SEARCH')}}</a>
                        <vue-json-to-csv :labels="labels" v-show="disabled == false" :csv-title="'Truckers'" :json-data="csv_josn"  class="btn btn-default yb-btn" > <button class="fas fa-file-csv" id="csv_id" ></button></vue-json-to-csv>
                        <a href="javascript:void(0);"  class="btn btn-info mr-2 " @click="trucker_csv(1)"><i class="fas fa-file-csv"></i></a>
                        <a href="javascript:void(0);"  class="btn btn-info mr-2 " @click="trucker_listing(0)"><i class="fas fa-sync-alt"></i></a>
                        <a type="button" class="btn btn-info  float-right" @click="$emit('add_user')"><i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                    </span>
                </div>
            </div>
            <table class="table">
            <thead>
                <tr>
                <th scope="col" >ID <i @click="sort('id')" class="far fa-arrows-v pointer"></i></th>
                <th scope="col" >{{ $t('message.NAME')}} <i @click="sort('name')" class="far fa-arrows-v pointer"> </i></th>
                <th scope="col">CVR <i  @click="sort('cvr')" class="far fa-arrows-v pointer"> </i></th>
                <th> {{ $t('message.TRUCK_NUMBER')}} <i @click="sort('truck_number')" class="far fa-arrows-v pointer"> </i> </th> 
                <th scope="col">{{ $t('message.WORK_INJURY')}} <i @click="sort('is_work_insurance')" class="far fa-arrows-v pointer"> </i></th>
                <th scope="col">{{$t('message.HAS_REG_NO')}}</th>
                <th scope="col">Motorregister</th>
                <th scope="col">KF</th>
                <th scope="col"> status <i @click="sort('status')" class="far fa-arrows-v pointer"> </i> </th>
                <th scope="col"> {{ $t('message.ACTION')}} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(trucker,index) in truckers " :key="index">
                <th scope="row">{{trucker.id}}</th>
                <td>{{trucker.name}}</td>
                <td>{{trucker.cvr}}</td>
                <td> {{trucker.truck_number}} </td>
                <td v-if="trucker.is_work_insurance == 1"> <i class="fa fa-check-circle" v-bind:style="{color: '#28a745', fontSize:'18px'}" aria-hidden="true"></i> </td>
                <td v-else>    <i class="fa fa-times-circle" v-bind:style="{color: '#dc3545', fontSize:'18px'}" aria-hidden="true"></i>  </td>
                <td>
                    <i v-if="trucker.vehicle" data-toggle="tooltip" data-placement="top" :title="trucker.vehicle.reg_number" class="fa fa-check-circle" v-bind:style="{color: '#28a745', fontSize:'18px'}" aria-hidden="true"></i>
                    <a v-else href="javascript:void(0);" @click="$emit('add_registration', trucker)"><i class="fa fa-times-circle" v-bind:style="{color: '#dc3545', fontSize:'18px'}" aria-hidden="true"></i></a>
                </td>
                <td>
                  {{ trucker.vehicle != null ? trucker.vehicle.status : ''  }}
                </td>
                <td v-if="trucker.vehicle != null && trucker.vehicle.insurance_status == 'verified'">
                  <i class="fa fa-check-circle" v-bind:style="{color: '#28a745', fontSize:'18px'}" aria-hidden="true"></i>
                </td>
                <td v-else-if="trucker.vehicle != null && trucker.vehicle.insurance_status == 'not verified'">
                  <i class="fa fa-times-circle" v-bind:style="{color: '#dc3545', fontSize:'18px'}" aria-hidden="true"></i>
                </td>
                <td v-else>
                  <i class="fa fa-exclamation-circle" v-bind:style="{color: '#FFFF00', fontSize:'18px'}" aria-hidden="true"></i>
                </td>
                <td v-if="trucker.status == 0">
                  <!-- {{ $t("message.UN_SIGN")}} -->
                  <i class="fa fa-check-circle" v-bind:style="{color: '#28a745', fontSize:'18px'}" aria-hidden="true"></i>
                </td>
                <td v-else>
                  <!-- {{ $t("message.SIGN")}} -->
                  <i class="fa fa-times-circle" v-bind:style="{color: '#dc3545', fontSize:'18px'}" aria-hidden="true"></i>
                </td>

                <td >
                    <!-- <a  href="javascript:void(0);" class="mr-2"><i class="fas fa-pencil-alt" @click="$emit('edit_trucker', trucker)"></i></a> -->
                    <a href="javascript:void(0);" @click="download_pdf(trucker.id)" class="mr-2"><i class="fas fa-file-pdf"></i></a>
                    <a :href="'./trucker-history/' + trucker.id" class="mr-2"><i class="fas fa-history"></i></a>
                    <a :href="'./truckers/edit/' + trucker.id" class="mr-2"><i class="fas fa-pencil-alt"></i></a>
                    <a v-if="trucker.is_work_insurance"  href="javascript:void(0);" class="mr-2" @click="resend_email(trucker.email,trucker.name,trucker.id)" data-toggle="tooltip" data-placement="top" title="Resend Email"><i class="fa fa-envelope" aria-hidden="true"></i></a>
                    <a  href="javascript:void(0);"  v-bind:style="{color: '#dc3545'}" v-on:click="delete_trucker(trucker.id)"><i class="fas fa-trash-alt"></i></a>
                </td>
                </tr>
            </tbody>
            </table>
            <paginate  v-if="pagination.pages"  :page-count="pagination.pages" :page-range="3" :margin-pages="2" :click-handler="trucker_listing" :prev-text="'<'" :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'" :first-last-button ="true" first-button-text="First" last-buttontext="Last">
            </paginate>
          </card>
        </div>
      </div>
 </div>
</template>

<script>
  import Card from '../../components/Cards/Card.vue'
  import Vue from 'vue'
  
  export default {
    components: {
      Card
    },
    data () {
      return {
        search_filter:['Name','Cvr','Truck number'],
        search_key:'',
        search_field:null,
        csv_josn:[],
        disabled:true,
        currentSort:'id',
        currentSortDir:'asc'
      }
    },
    computed: {
        truckers() {
            return this.$store.getters['trucker/allTruckers']
        },
        pagination() {
            return this.$store.getters['trucker/getPagination']
        },
        labels()
        {
          return {
              name:{title:this.$t('message.NAME')},
              email: {title:this.$t('message.EMAIL')},
              cvr: {title:"CVR"},
              truck_number: {title:this.$t('message.TRUCK_NUMBER')},
              reg_number: {title:this.$t('message.CAR') +' '+'Reg No'},
              serial_number: {title:this.$t('message.FRAME_NO')},
              is_work_insurance:{title:this.$t('message.WORK_INJURY')},
              has_reg_no: {title:this.$t('message.HAS_REG_NO')},
              vejhjaelp: {title: 'Vejhjaelp'},
              glasskade: {title: 'Glasskade'},
              injury_valid_from: {title: 'Arbejdsskade gyldig fra'},
              injury_comment: {title: 'Kommentar til arbejdsskade'},
              addon_1_date: {title: 'Vejhjælp aktiv pr'}
          }
        }
    },
    methods:{
          sort:function(s) {
              if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
              } else this.currentSortDir = 'asc'
              this.currentSort = s;

              this.trucker_listing(0)
          },
          async trucker_listing(page_num = 0, sort=null) {
                // console.log(document.getElementById('mycheck').click());
                this.search_key = ''
                this.search_field = null
                let loader = this.$loading.show()
                try 
                {
                  await this.$store.dispatch('trucker/get_truckers', {page_num: page_num,currentSort:this.currentSort, currentSortDir: this.currentSortDir, pagination: true})
                  loader.hide()
                }
                catch(e) 
                {
                  this.$store.dispatch("notifications_alert/error", "Oops, something went wrong!")
                  loader.hide()
                }
            },

            async trucker_csv(id) {
              let loader = this.$loading.show()
              try {
                const  data = await this.$store.dispatch('trucker/get_truckers', {
                  page_num: 1,
                  currentSort:'id',
                  currentSortDir:'asc',
                  pagination: false
                })
                
                if(data.data.truckers.data)
                {
                  let temp = []
                  await data.data.truckers.data.forEach(element => {
                    let vejhjaelp = ''
                    let glasskade = ''
                    let injury_valid_from, injury_comment, addon_1_date = ''
                    if( element.trucker_agreement != null ) {
                        vejhjaelp = element.trucker_agreement.addon_1 == 1 ? 'Ja' : 'Nej'
                        glasskade = element.trucker_agreement.addon_2 == 1 ? 'Ja' : 'Nej'
                        injury_valid_from = element.trucker_agreement.injury_valid_from != null && typeof element.trucker_agreement.injury_valid_from != 'undefined' ? element.trucker_agreement.injury_valid_from : ''
                        injury_comment = element.trucker_agreement.injury_comment != null && typeof element.trucker_agreement.injury_comment != 'undefined' ? element.trucker_agreement.injury_comment : ''
                        addon_1_date = element.trucker_agreement.addon_1_date != null ? element.trucker_agreement.addon_1_date : ''
                    }
                    
                    // vejhjaelp = element.trucker_agreement?.addon_1 || '';
                    // glasskade = element.trucker_agreement?.addon_2 || '';
                    temp.push({
                        name: element.name,
                        email: element.email,
                        cvr: element.cvr,
                        truck_number: element.truck_number,
                        reg_number: element.vehicle == null ? 'N/A' : element.vehicle.reg_number,
                        serial_number: element.vehicle == null ? 'N/A' : element.vehicle.serial_number,
                        is_work_insurance: element.is_work_insurance == 1 ? this.$t('message.YES') : this.$t('message.NO'),
                        has_reg_no:element.vehicle != null ? this.$t('message.YES') : this.$t('message.NO'),
                        vejhjaelp: vejhjaelp,
                        glasskade: glasskade,
                        injury_valid_from: injury_valid_from != undefined ? injury_valid_from : '',
                        injury_comment: injury_comment != undefined ? injury_comment : '',
                        addon_1_date: addon_1_date
                    })
                  });
                  
                  this.csv_josn = temp
                  if( id==1 ) {
                    document.getElementById('csv_id').click()
                  }
                } else {
                  this.$store.dispatch("notifications_alert/error", "Oops, something went wrong!")
                }
                loader.hide()
                this.trucker_listing()
              } catch(e) {
                this.$store.dispatch("notifications_alert/error",e)
                loader.hide()
              }
            },
 
            async search_tucker(page_num = 0) {
            let form_data = {
                search_key: this.search_key,
                search_filter: this.search_field == null ? 'name' : this.search_field,
                page_num: 0,
                pagination: true
            }
            let loader = this.$loading.show()
            try {
                await this.$store.dispatch('trucker/search_trucker', form_data)
                loader.hide()
            } catch (e) {
                loader.hide()
                this.$store.dispatch("notifications_alert/error", "Oops, something went wrong!")
            }
        },

        async delete_trucker(trucker_id) {

          this.$confirm(
          {
            message: this.$t('message.ARE_YOU_SURE'),
            button: {
              no: this.$t('message.NO'),
              yes: this.$t('message.YES')
            },
            /**
            * Callback Function
            * @param {Boolean} confirm 
            */
            callback: confirm => {
              if (confirm) {
                  let loader = this.$loading.show()
                  try {
                    this.$store.dispatch('trucker/delete_trucker', trucker_id)
                    loader.hide()
                  } catch (e) {
                    this.$store.dispatch('notifications_alert/error', "Oops, something went wrong!")
                    loader.hide()
                  }
              }
            }
          }
          )         
        },
        
        async resend_email(email, name, trucker_id) {

          let form_data = {
            email: email,
            name: name,
            trucker_id: trucker_id,
            locale:localStorage.getItem('lang')
          }

          let loader = this.$loading.show()
          try 
          {
            const resp = await Vue.prototype.$http.post('/api/truckers/resend-email',form_data)
            this.$store.dispatch("notifications_alert/success", resp.data.message)
            loader.hide()
          }
          catch(e) 
          {
            this.$store.dispatch("notifications_alert/error", "Oops, something went wrong!")
            loader.hide()
          }
        },

        async download_pdf(trucker_id) {
          let loader = this.$loading.show()
          try {
            const resp = await Vue.prototype.$http.get(`/api/truckers/send-certificate/${trucker_id}`)
            if (resp.data && resp.data.message) {
              this.$store.dispatch("notifications_alert/success", resp.data.message)
            } else {
              this.$store.dispatch("notifications_alert/success", "Certificate sent successfully!")
            }
            loader.hide()
          }
          catch(e) {
            let errorMsg = "Oops, something went wrong!"
            if (e.response && e.response.data && e.response.data.message) {
              errorMsg = e.response.data.message
            }
            this.$store.dispatch("notifications_alert/error", errorMsg)
            loader.hide()
          }
        }
    },
    created()
    {
      //this.trucker_csv(0)
      this.trucker_listing()
    }
  }
</script>

<style>
.pointer {
  cursor: pointer;
}

</style>